module.exports = __webpack_public_path__ + "img/profile-admin.433669fc.png";